export default "__VITE_ASSET__3e90ba4d__"